import React, { Component } from 'react';
import ModalModule from '../modal';
import PluginInterface from '../naws/PluginInterface';
import { WrappedButton, WrappedButtonType } from '../ui/button';
import { WrappedDropdown } from '../ui/input';
import Utils from '../utils';

const { Modal } = ModalModule;
const { Util, withLayoutAndModalContexts } = Utils;

class ConnectPrintModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			computer: PluginInterface.activeDevice,
			computers: PluginInterface.deviceList,
			printers: this.getPrinters(),
			trays: [],
		};
	}

	/**
	 * Return modal header text based on type of print and quantity
	 * @returns {string}
	 */
	getHeader = () => 'Print';

	/**
	 * Retrieve the list of printers from PluginInterface
	 * @returns {Array}
	 */
	getPrinters = () => {
		let printers = [];
		PluginInterface.getPrinterInfo(printerInfo => {
			printers = printerInfo?.printer;
		});
		return printers;
	};

	/*
	 * Print button click handler
	 */
	onPrintClick = () => {
		const { printer, tray } = this.state;
		const {
			data: { callback },
			modalId,
		} = this.props;

		if (callback) {
			callback(printer ? printer.value : null, tray, modalId);
		}
	};

	onRefreshClick = () => {
		PluginInterface.refreshPrinters(filteredPrinters => {
			this.setState({ printers: filteredPrinters });
		});
	};

	render() {
		const { modalId, data } = this.props;
		const { labels } = data || {};
		const { computer, computers, printer, printers, tray } = this.state;
		const computerNames = computers.map(
			computerItem => computerItem.DeviceName
		);
		const printerNames = printers.map(printerItem => printerItem.name);
		// find the printer object from the printers array that matches the selected printer name
		const selectedPrinter = printers.find(
			p => p.name === (printer ? printer.value : null)
		);
		// update the trays state with trays from the selected printer
		const trays = selectedPrinter ? selectedPrinter.tray : [];
		const trayNames = trays.map(trayItem => trayItem.name);

		return (
			<Modal
				modalId={modalId}
				className="common-print-modal"
				header={this.getHeader()}
				labels={labels}
				hideFooter
			>
				{/* custom body */}
				<div className="dialog-body">
					<div className="p-grid p-nogutter">
						{PluginInterface.showDeviceSelection && (
							<>
								<div className="p-col-3 label">Computer:</div>
								<div className="p-col-9">
									<WrappedDropdown
										options={computerNames}
										value={computer?.DeviceName || null}
										disabled={computers.length === 0}
										dataqa="connect-print-selected-computer"
										onChange={value => {
											const selectedComputer = computers.find(
												item => item.DeviceName === value.value
											);
											this.setState({ computer: selectedComputer }, () => {
												Util.setCookie(
													'PreferredNawsSession',
													selectedComputer?.SessionID,
													365
												);
												PluginInterface.setActiveDevice(selectedComputer);
												this.setState({ printers: this.getPrinters() });
											});
										}}
										label="Computer"
									/>
								</div>
								<div className="p-col-12">&nbsp;</div>
							</>
						)}

						<div className="p-col-3 label">Printer:</div>
						<div className="p-col-8">
							<WrappedDropdown
								options={printerNames}
								value={printer ? printer.value : null}
								disabled={printers.length === 0}
								onChange={value => this.setState({ printer: value })}
								dataqa="connect-print-selected-printer"
								label="Printer"
							/>
						</div>
						<div className="p-col-1">
							{/* refresh button */}
							<span
								className="warning-icon pi pi-sync"
								onClick={this.onRefreshClick}
							/>
						</div>
						<div className="p-col-12">&nbsp;</div>

						<div className="p-col-3 label">Paper Tray:</div>
						<div className="p-col-9">
							<WrappedDropdown
								options={trayNames}
								value={tray || null}
								disabled={trays.length === 0}
								onChange={value => this.setState({ tray: value.value })}
								dataqa="connect-print-selected-tray"
								label="Tray"
							/>
						</div>
					</div>
				</div>

				{/* custom Footer */}
				<div className="p-dialog-footer custom-footer">
					<WrappedButton
						buttonType={WrappedButtonType.Primary}
						label="Print"
						onClick={this.onPrintClick}
						dataqa="connect-print-print"
					/>
				</div>
			</Modal>
		);
	}
}

export default withLayoutAndModalContexts(ConnectPrintModal);
